import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LayoutLibraryModule} from '../_layout-library/layout-library.module';
import { AuditModalComponent } from './pages/audit-modal/audit-modal.component';
import { AuditListComponent } from './components/audit-list/audit-list.component';
import { AuditListEntryComponent } from './components/audit-list-entry/audit-list-entry.component';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [
    AuditModalComponent,
    AuditListComponent,
    AuditListEntryComponent,
  ],
  exports: [
    AuditModalComponent
  ],
  imports: [
    CommonModule,
    LayoutLibraryModule,
    FormsModule,
  ]
})
export class AuditModule { }
